import { createRequest, getEndpoint } from "../requestCreator";

export const getLicense = createRequest(getEndpoint("license.sub.get"));
export const installLicense = createRequest(getEndpoint("license.sub.install"));
